export const NIKA_EMAIL = ['tilaus@nika.fi'];

export const EMAIL_ADDRESSES = ['teemu.pasanen@nika.fi', 'tilaus@nika.fi'];

export const EMAIL_TEST = ['lauri.roukala@ssadigi.com', 'carlos.osorio@ssadigi.com', 'dalton.gutierrez@ihme3d.com'];

export const MAIL_TEMPLATE_ID = "d-8e7143faa61f464590e9abebd3cb34f5";

export const MAIL_TEMPLATE_ID_AUTH = "d-70125803c04b43889927996258b5ac2e";